<template>

    <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center">
                <button @click="goToMenus" class="btn btn-sm btn-secondary mr-2" title="Volver a Menús">
                    <font-awesome-icon :icon="['fas', 'angle-left']"/>
                    Menús
                </button>
                <h6 class="mb-0 text-muted" v-if="menuName">Submenús de <strong>{{ menuName }}</strong></h6>
            </div>
            <button class="btn btn-primary" @click="openCreateModal">
                <font-awesome-icon :icon="['fas', 'plus']"/>
                {{ $t('global.buttons.add') }}
            </button>
        </div>
        <table-server :columns="table.columns" :options="tableOptions" :url="urlSubMenus" class="text-center"
                      ref="table">
            <div class="table-name" slot="name" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.name }}
            </div>
            <div class="table-icon" slot="icon" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.icon }}
            </div>
            <div class="table-slug" slot="slug" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.slug }}
            </div>
            <div class="table-path" slot="path" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.path }}
            </div>
            <div class="table-target_site" slot="target_site" slot-scope="props" style="font-size: 0.9em">
                {{ props.row.target_site }}
            </div>
            <div class="table-actions" slot="actions" slot-scope="props" style="white-space: nowrap;padding: 5px;">
                <button @click="openEditModal(props.row)" class="btn btn-sm btn-outline-primary mr-1"
                        title="Editar">
                    <font-awesome-icon :icon="['fas', 'edit']"/>
                </button>
                <button @click="showDeleteModal(props.row.id,props.row.name)" class="btn btn-sm btn-outline-primary"
                        title="Eliminar">
                    <font-awesome-icon :icon="['fas', 'trash']"/>
                </button>
            </div>
            <div class="table-loading text-center" slot="loading">
                <img alt="loading" height="51px" src="/images/loading.svg"/>
            </div>
        </table-server>

        <b-modal :title="modalTitle" centered ref="form-modal">
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label for="name">Nombre</label>
                    <input :class="{'form-control':true}" id="name" name="name" type="text"
                           v-model="form.name" v-validate="'required'">
                    <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;" v-show="errors.has('name')">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-left: 5px;"/>
                        <span>{{ errors.first('name') }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="icon">Icono</label>
                    <input :class="{'form-control':true}" id="icon" maxlength="20" name="icon"
                           placeholder="ej: box" type="text" v-model="form.icon" v-validate="'required'">
                    <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;" v-show="errors.has('icon')">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-left: 5px;"/>
                        <span>{{ errors.first('icon') }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="slug">Slug</label>
                    <input :class="{'form-control':true}" id="slug" name="slug" type="text" v-model="form.slug">
                </div>
                <div class="form-group">
                    <label for="path">Path</label>
                    <input :class="{'form-control':true}" id="path" name="path" type="text" v-model="form.path">
                </div>
                <div class="form-group">
                    <label for="target_site">Sitio</label>
                    <select :class="{'form-control':true}" id="target_site" name="target_site"
                            v-model="form.target_site" v-validate="'required'">
                        <option value="a2">a2</option>
                        <option value="a3">a3</option>
                        <option value="sld">sld</option>
                    </select>
                    <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;"
                         v-show="errors.has('target_site')">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-left: 5px;"/>
                        <span>{{ errors.first('target_site') }}</span>
                    </div>
                </div>
            </form>
            <div slot="modal-footer">
                <button :disabled="saving" @click="submitForm" class="btn btn-success">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" v-if="saving"></span>
                    {{ $t('global.buttons.submit') }}
                </button>
                <button :disabled="saving" @click="hideFormModal" class="btn btn-danger">
                    {{ $t('global.buttons.cancel') }}
                </button>
            </div>
        </b-modal>

        <b-modal :title="deleteName" centered ref="delete-modal" size="sm">
            <p class="text-center">{{ $t('global.message_delete') }}</p>
            <div slot="modal-footer">
                <button :disabled="deleting" @click="remove()" class="btn btn-success">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" v-if="deleting"></span>
                    {{ $t('global.buttons.accept') }}
                </button>
                <button :disabled="deleting" @click="hideDeleteModal()" class="btn btn-danger">
                    {{ $t('global.buttons.cancel') }}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {API} from './../../../api'
import TableServer from '../../../components/TableServer'
import BModal from 'bootstrap-vue/es/components/modal/modal'

export default {
    components: {
        'table-server': TableServer,
        BModal
    },
    data() {
        return {
            menuName: '',
            deleteName: '',
            deleteId: null,
            appId: this.$route.params.app_id,
            menuId: this.$route.params.menu_id,
            urlSubMenus: '/api/menus/' + this.$route.params.menu_id + '/sub_menus?token=' +
                window.localStorage.getItem('access_token') + '&lang=' + localStorage.getItem('lang'),
            table: {
                columns: ['id', 'name', 'icon', 'slug', 'path', 'target_site', 'actions'],
            },
            formAction: 'post',
            editingId: null,
            modalTitle: 'Nuevo submenú',
            saving: false,
            deleting: false,
            form: {
                name: '',
                icon: '',
                slug: '',
                path: '',
                menu_id: this.$route.params.menu_id,
                target_site: 'a2'
            }
        }
    },
    computed: {
        tableOptions: function () {
            return {
                headings: {
                    id: 'ID',
                    name: this.$i18n.t('global.name'),
                    icon: 'Icono',
                    slug: 'Slug',
                    path: 'Path',
                    target_site: 'Sitio',
                    actions: this.$i18n.t('global.table.actions')
                },
                sortable: ['id'],
                filterable: ['id']
            }
        }
    },
    mounted() {
        this.$i18n.locale = localStorage.getItem('lang')
        API.get('/menus/' + this.menuId)
            .then((result) => {
                this.menuName = result.data.data.name
            }).catch(() => {
        })
    },
    methods: {
        goToMenus() {
            this.$router.push({name: 'MenusList', params: {app_id: this.appId}})
        },
        openCreateModal() {
            this.formAction = 'post'
            this.editingId = null
            this.modalTitle = 'Nuevo submenú'
            this.form = {name: '', icon: '', slug: '', path: '', menu_id: this.menuId, target_site: 'a2'}
            this.errors.clear()
            this.$refs['form-modal'].show()
        },
        openEditModal(row) {
            this.formAction = 'put'
            this.editingId = row.id
            this.modalTitle = 'Editar submenú'
            this.form = {
                name: row.name,
                icon: row.icon,
                slug: row.slug,
                path: row.path,
                menu_id: this.menuId,
                target_site: row.target_site
            }
            this.errors.clear()
            this.$refs['form-modal'].show()
        },
        hideFormModal() {
            this.$refs['form-modal'].hide()
        },
        submitForm() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Submenús',
                        text: this.$t('servicetypes.error.messages.information_complete')
                    })
                    return
                }
                this.saving = true
                API({
                    method: this.formAction,
                    url: 'sub_menus/' + (this.editingId !== null ? this.editingId : ''),
                    data: this.form
                }).then((result) => {
                    this.saving = false
                    if (result.data.success === false) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Submenús',
                            text: this.$t('servicetypes.error.messages.information_error')
                        })
                    } else {
                        this.hideFormModal()
                        this.onUpdate()
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Submenús',
                            text: this.editingId !== null ? 'Submenú actualizado' : 'Submenú creado'
                        })
                    }
                }).catch(() => {
                    this.saving = false
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Submenús',
                        text: this.$t('servicetypes.error.messages.connection_error')
                    })
                })
            })
        },
        showDeleteModal(sub_menu_id, sub_menu_name) {
            this.deleteId = sub_menu_id
            this.deleteName = sub_menu_name
            this.$refs['delete-modal'].show()
        },
        hideDeleteModal() {
            this.$refs['delete-modal'].hide()
        },
        remove() {
            this.deleting = true
            API({
                method: 'DELETE',
                url: 'sub_menus/' + this.deleteId
            })
                .then((result) => {
                    this.deleting = false
                    if (result.data.success === true) {
                        this.onUpdate()
                        this.hideDeleteModal()
                    } else {
                        this.hideDeleteModal()
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Submenús',
                            text: this.$t('global.error.delete')
                        })
                    }
                }).catch(() => {
                this.deleting = false
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Submenús',
                    text: this.$t('servicetypes.error.messages.connection_error')
                })
            })
        },
        onUpdate() {
            this.urlSubMenus = '/api/menus/' + this.menuId + '/sub_menus?token=' +
                window.localStorage.getItem('access_token') + '&lang=' + localStorage.getItem('lang')
            this.$refs.table.$refs.tableserver.refresh()
        },
    }

}
</script>

<style lang="stylus">

</style>
